// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"232":"d26769d2","574":"7b064d4f","884":"5b13b05f"}[chunkId] + ".chunk.js";
};